<template>
  <Container>
    <div class="flex-wrap flex-between" style="padding:0 10px">
      <Toolbar
        :items="tools"
        v-model="filter"
        :counts="counts"
        @on-event="handleEvent"
      />

      <div class="flex-wrap">
      <Button style="margin-right:5px" icon="md-add" type="primary" @click="showCreateForm">新建项目</Button>
      <Button style="margin-left:5px" icon="md-download" @click="exportExcel" />
      </div>
    </div>
    <div style="height:calc(100% - 40px);padding:0 5px;">
        <BaseTable
            ref="table"
            :columns="columns"
            :data="items"
            :page="page"
            :page-size="pagesize"
            @event="handleEvent"
            :loading="loading"
            :count="total"
            border
        />
    </div>

    <Editor
      ref="editor"
      :width="900"
      v-model="showEditor"
      :data="current"
      model="BU_Sign_Project"
      @on-event="handleEvent"
    />
  </Container>
</template>

<script>
import Container from '@/components/app/container';
import Toolbar from '@/components/app/toolbar';
import Editor from '@/components/model/editor';
import moment from 'moment';
import {cloneDeep} from 'lodash';
export default {
  routerOption: {
    as_default: true,
  },
  components: {Container, Toolbar, Editor},
  data() {
    return {
      showEditor: false,
      items: [],
      loading: false,

      current: {},
      formData: {},
      filter: {
      }, counts: {
        '草稿': 0,
        '审核中': 0,
        '审核通过': 0,
        '不通过': 0,
      }, order: {
        key: 'created_by',
        order: 'desc',
      }, page: 1,
      pagesize: 20,
      total: 10,
    };
  },
  computed: {
    tools() {
      return [{
        key: 'search',
        placeholder: '输入项目名称/招标单位/搜索',
        type: 'search',
        width: 300,
      }, {
        key: 'status',
        type: 'tabs',
        subs: [{
          key: '草稿',
          icon: 'file',
          countable: true,
          name: '草稿',
        }, {
          key: '审核中',
          icon: 'date',
          countable: true,
          name: '审核中',
        }, {
          key: '已签约',
          icon: 'pm2',
          countable: true,
          name: '已签约',
        }, {
          key: '已发放',
          icon: 'xiangmu2',
          countable: true,
          name: '已发放',
        }],
      }, {
        key: 'refresh',
        icon: 'md-refresh',
        type: 'icon-button',
      }, {
        key: 'clearFilter',
        icon: 'md-filter',
        type: 'icon-button',
      }];
    },
    columns() {
      return [{type: 'index', width: 80, title: '序号'},
        {key: 'code', width: 80, title: '编号'},
        {key: 'name', minWidth: 240, title: '项目名称', sortable: 'custom',
          render: (h, {row})=>{
            const icon = h('BaseIcon', {props: {icon: 'Building-', size: 16, color: 'var(--primary)'}, style: 'margin-left:10px;margin-right:5px;'});
            let tag = h('img', {attrs: {
              src: 'https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif',
            }, style: 'width:30px;height:15px;margin-left:5px;margin-right:10px;'});
            if (moment().subtract(3, 'days').isAfter(moment(row.created_by))) {
              tag = '';
            }
            const name = h('div', {attrs: {title: row.name}, style: 'white-space:nowrap;text-overflow:ellipsis;width:calc(100% - 50px;);overflow:hidden;'}, row.shortname || row.name);
            return h('div', {
              class: 'flex-wrap',
              style: {
                color: 'var(--primary)',
                fontWeight: 'bold',
                textAlign: 'left',
                cursor: 'pointer',
              },
              on: {
                click: ()=>{
                  this.Edit(row);
                },
              },
            }, [icon, name, tag]);
          },
        }, {
          key: 'status', width: 120,
          type: 'state',
          title: '阶段', sortable: 'custom',
        }, {
          key: 'entrust_form',
          title: '委托形式',
          type: 'state',
          width: 120,
          option: {
            states: ['招标委托', '直接委托'],
          },
          sortable: 'custom',
        }, {
          key: 'filing_personnel_selection_process',
          title: '备案人员选配流程',
          type: 'flow',
          width: 120,
          sortable: 'custom',
        }, {
          key: 'contract_review_process',
          title: '合同编审流程',
          type: 'flow',
          width: 120,
          sortable: 'custom',
        }, {
          key: 'status',
          title: '合同履约担保',
          align: 'center',
          width: 300,
          children: [{
            key: 'payment_form',
            width: 100,
            title: '缴纳形式',
            type: 'state',
            // option:{
            //   states:['现金','银行保函','保兑支票','银行汇票','现金支票']
            // },
          }, {
            key: 'payment_amount',
            width: 100,
            type: 'number',
            option: {
              type: 'amount',
            },
            title: '缴纳金额',
          }, {
            key: 'payment_date',
            type: 'time',
            option: {
              type: 'date',
            },
            width: 100,
            title: '缴纳日期',
          }],
        }, {
          key: 'personnel_contract_system_entry',
          title: '人员及合同系统录入',
          type: 'text',
          width: 160,
          sortable: 'custom',
        }, {
          key: 'contract_distribution_record',
          title: '合同发放记录',
          type: 'text',
          width: 120,
          sortable: 'custom',
        }, {
          key: 'contract_code',
          title: '合同编码',

          width: 120,
          sortable: 'custom',
        }, {
          key: 'archives',
          title: '资料归档',
          align: 'center',
          width: 240,
          children: [{
            key: 'bid_notice_files',
            width: 120,
            type: 'file',
            title: '中标通知书',
          }, {
            key: 'contract_files',
            width: 100,
            type: 'file',
            title: '合同',
          }]}, {key: 'tools', width: 200, title: '操作', sortable: false,
          fixed: 'right',
          render: (h, {row})=>{
            const that = this;
            const buttons = [
              h('Button', {props: {size: 'small'}, on: {click: ()=>{
                that.Edit(row);
              }}}, '修改'),
              h('Button', {props: {size: 'small'}, on: {click: ()=>{
                that.handleDelete(row);
              }}}, '删除'),
              // h('Button',{props:{size:'small',type:'primary'},on:{click:()=>{that.CreateNext(row)}}},'创建合同')
            ];
            return h('div', {class: 'flex-wrap flex-center', style: 'gap:4px'}, [buttons]);
          },
        }];
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    showCreateForm() {
      this.current = {};
      this.formData = {};
      this.showEditor = true;
    },
    Edit(item) {
      this.loadingEditor = true;
      this.showEditor = true;
      this.$api.get(`business/sign_projects/${item.id}?edit=1`).then((res)=>{
        this.current = res.data.data;
        this.loadingEditor = false;
        this.formData = cloneDeep(this.current);
        this.showEditor = true;
      }).catch((e)=>{
        this.loadingEditor = false;
        this.loadingEditorError = true;
      });
    },
    getData() {
      this.loading = true;
      this.$api.afterLogin(()=>{
        this.$api.getPaged('/business/sign_projects', {
          page: this.page,
          pagesize: this.pagesize,
          order: this.order,
          filter: this.filter,
          related: ['project_info', 'contract_info', 'performance_bond', 'contract_files', 'bid_notice_files'],
        }).then((res)=>{
          const {count, list} = res.data.data;
          list.forEach((v)=>{
            Object.assign(v, v.project_info);
            v.entrust_form = v.contract_info.entrust_form;
            v.contract_code = v.contract_info.contract_code;
            Object.assign(v, v.performance_bond);
          });
          this.items = list;
          this.total = count;
          this.loading = false;
        });
      });
    },
    createItem(model) {
      this.$api.post('/business/sign_projects', model).then((res)=>{
        this.$Notice.success({title: '创建成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    }, updateItem(model) {
      const id = this.current.id;
      this.$api.patch(`/business/sign_projects/${id}`, model).then((res)=>{
        this.$Notice.success({title: '修改成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    }, exportExcel() {
      this.$refs.table.exportExcel();
    }, handleDelete(item) {
      this.Confirm(`即将删除此项目<span style="color:var(--error)">${item.name}</span>，是否继续?`, ()=>{
        this.$api.delete('/business/sign_projects/'+item.id).then((res)=>{
          this.$Notice.success({title: '删除成功'});
          this.getData();
        });
      });
    },
    handleEvent({type, key, value, data}) {
      const eventMap = {
        'add': this.showCreateForm,
        'search': this.getData,
        'create': this.createItem,
        'refresh': ()=>{
          this.getData();
        },
        'update': this.updateItem,
        'tab-change': this.getData,
        'page-change': ()=>{
          this.page = data;
          this.getData();
        },
        'page-size-change': ()=>{
          this.pagesize = data;
          this.getData();
        },
        'sort': ()=>{
          if (!data || !data.key) {
            this.order = null;
          } else {
            this.order = data;
          }
          this.getData();
        },
      };


      let eventHandler = eventMap[type];
      if (eventHandler) {
        eventHandler(value);
      } else {
        eventHandler = eventMap[key];
        if (eventHandler) {
          eventHandler(value);
        }
      }
    },
  },
};
</script>

<style>

</style>
